package com.essntl.core.axus.data

import com.essntl.config.EssntlConfig
import com.essntl.core.axus.domain.AxusClient
import com.essntl.core.axus.domain.AxusItinerary
import com.essntl.core.network.IO
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.basicAuth
import io.ktor.client.request.header
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

internal class AxusClientImpl(
    private val httpClient: HttpClient,
) : AxusClient {
    override suspend fun insert(itinerary: AxusItinerary): Result<AxusItinerary> {
        return runCatching {
            withContext(Dispatchers.IO) {
                httpClient.put(BASE_URL) {
                    header(HttpHeaders.ContentType, ContentType.Application.Json)
                    header("ClientId", EssntlConfig.axusClientId)
                    basicAuth(EssntlConfig.axusUsername, EssntlConfig.axusPassword)
                    setBody(itinerary)
                }.body<AxusItinerary>()
            }
        }
    }

    companion object {
        private const val BASE_URL = "https://axustravelapp.com/api/v1/push/itinerary"
    }
}
